/* eslint-disable @typescript-eslint/no-unused-vars */
import React from 'react';
import {Button} from "antd";
import styles from './CarTypes.module.scss';
import {CarTypeType} from "../PointAdjust.interface";

interface CarTypesProps {
	selectedCarType?: CarTypeType;
	onClick: (carType: CarTypeType) => any;
}

const CarTypes = ({selectedCarType, onClick}: CarTypesProps) => {
	const getClassName = (carType?: CarTypeType) => {
		return selectedCarType === carType ? styles.selected : '';
	};

	return (
		<div className={styles.wrap}>
			<Button className={getClassName('all')} onClick={() => onClick('all')}>전체</Button>
			<Button className={getClassName('1t')} onClick={() => onClick('1t')}>1t</Button>
			<Button className={getClassName('2t')} onClick={() => onClick('2t')}>2t</Button>
			<Button className={getClassName('3t')} onClick={() => onClick('3t')}>3t</Button>
			<Button className={getClassName('5t')} onClick={() => onClick('5t')}>5t</Button>
			<Button className={getClassName('5t_over')} onClick={() => onClick('5t_over')}>5t초과</Button>
		</div>
	);
}


export default CarTypes;
